import { config } from '@/config';
import { createApp } from '@shopify/app-bridge';
import { Redirect } from '@shopify/app-bridge/actions';
import { useLocation } from 'react-router-dom';
import { useMemo } from 'react';

export const useRedirect = () => {
  const location = useLocation();

  const configApp = useMemo(
    () => ({
      apiKey: process.env.REACT_APP_API_KEY || '',
      host: new URLSearchParams(location.search).get('host') || 'YWRtaW4uc2hvcGlmeS5jb20vc3RvcmUveW91cnNob3AtZGV2',
      forceRedirect: process.env.REACT_APP_MODE === 'live' && config.scope !== 'omegatheme',
    }),
    [location.search],
  );

  const app = useMemo(() => createApp(configApp), [configApp]);
  const redirect = useMemo(() => Redirect.create(app), [app]);

  const redirectTo = (url: string) => {
    redirect.dispatch(Redirect.Action.REMOTE, url);
  };

  return { redirectTo };
};
